<template>
  <Toolbar
    :class="props.class"
    class="rounded-none h-16 w-full py-0 flex-nowrap"
    :pt="{
      root: { class: 'justify-stretch' },
      center: { class: 'flex-none' },
      start: { class: 'flex-1' },
      end: { class: $slots.center ? 'flex-1' : '' },
    }"
  >
    <template #start>
      <slot name="start"></slot>
    </template>
    <template #center>
      <slot name="center"></slot>
    </template>
    <template #end>
      <slot name="end"></slot>
    </template>
  </Toolbar>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: string;
}>();
</script>

<style scoped></style>
